import { AuthProviderProps } from 'react-oidc-context'
import { WebStorageStateStore } from 'oidc-client-ts'

export const oidcConfig: AuthProviderProps = {
  authority: `${process.env.REACT_APP_KEYCLOAK_URL}`,
  client_id: 'ouvidoria',
  redirect_uri: window.location.href,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname)
  },
  post_logout_redirect_uri: `${window.location.origin}`,
  // O scope 'roles' (embutido do OIDC) foi retirado de proposito: ele so alimenta o
  // resource_access do access token, e ninguem mais le de la — backend e frontend pegam as
  // roles do groups, pelo userinfo. Com ele, o JWT do usuario com muitos perfis passava de
  // 21 KB e o servidor dos estaticos recusava a requisicao com 431.
  // 'ouv_roles' TEM que ficar: e ele que faz o mapper do groups rodar, inclusive no userinfo.
  scope: 'openid foto profile matricula orgaos cargo ouv_roles orgaoExterno',
  metadata: {
    issuer: `${process.env.REACT_APP_KEYCLOAK_URL}`,
    authorization_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/auth`,
    token_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/token`,
    introspection_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/token/introspect`,
    userinfo_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/userinfo`,
    end_session_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/logout`,
    jwks_uri: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/certs`,
    check_session_iframe: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/login-status-iframe.html`,
    registration_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/clients-registrations/openid-connect`,
    revocation_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/revoke`,
  },
}
